import FullscreenDecorator from '../lib/FullscreenDecorator.js';
import ModalOverlay from '../lib/ModalOverlay.js';
import el from '@finn-no/create-element';

export default {
    dependencies: ['$element', '$controllerator'],
    callable(ele, controllerator) {
        let dialog;
        const inputEle = ele.elements.q;

        const FullscreenModalOverlay = FullscreenDecorator(ModalOverlay);

        // Opening on touchend is faster than focusing the input and then opening, because
        // we can skip at least one layout in the middle of opening the modal.
        // In theory we could use focusin, but that fires after focus in most browsers :(
        inputEle.addEventListener('touchstart', event => {
            // FIXME: in iOS 10 we have to run preventDefault(), otherwise the input doesn't get focused.
            // This might be a bug. In some Android versions, we can't runt preventDefault(), because
            // the overlay doesn't open at all. Should try to solve this without special-casing iOS.
            if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
                event.preventDefault();
            }
            inputEle.addEventListener('touchend', handle);
            inputEle.addEventListener('touchmove', reset);
        });

        function handle(event) {
            event.stopPropagation();
            event.preventDefault();
            showFullscreenDialog();
        }

        function reset() {
            inputEle.removeEventListener('touchend', handle);
            inputEle.removeEventListener('touchmove', reset);
        }

        // The focus event is sometimes triggered by autofocus even if this is done on
        // DOMContentLoaded (bug?). setTimeout() prevents this from happening.
        window.setTimeout(() => {
            inputEle.addEventListener('focus', showFullscreenDialog);
        });

        function showFullscreenDialog() {
            if (ModalOverlay.isOpen) {
                return;
            }

            const contentEle = createDialogContent();

            const options = {
                size: {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                },
                onHideFocusElement: ele.querySelector(
                    '[data-fullscreen-search-focus]'
                ),
                slide: true,
            };

            dialog = new FullscreenModalOverlay('Søk', contentEle, options);
            dialog.show();

            removeFullscreenController(contentEle);
            controllerator.run();
        }

        function createDialogContent() {
            const formEle = ele.cloneNode(true);
            formEle.classList.add('r-margin');
            formEle.removeAttribute('data-is-dropdown');
            const submitButtonEle = formEle.querySelector('button');
            if (submitButtonEle) {
                submitButtonEle.remove();
            }
            const inputEle = formEle.elements.q;
            inputEle.style.cssText = '-webkit-flex: 1; -ms-flex: 1; flex: 1;';
            const buttonEle = el(
                'button.blank.prn',
                {
                    type: 'button',
                    onclick: hideDialog,
                },
                'Avbryt'
            );
            const insertionEle = formEle.querySelector(
                '[data-dropdown-insertion]'
            );
            insertionEle.className = 'r-phl scroll-container';
            insertionEle.style.top = '60px';

            // Lots of flashing without this. Which is weird, becuse it's already
            // a layer due to -webkit-overflow-scrolling: touch
            insertionEle.style.webkitTransform = 'translate3d(0, 0, 0)';
            insertionEle.style.transform = 'translate3d(0, 0, 0)';

            // Rearrange so that flex works properly
            formEle.append(
                el('div.flex', null, inputEle, el('span', null, buttonEle)),
                insertionEle
            );

            if (inputEle.type === 'search') {
                inputEle.selectionStart = inputEle.value.length;
            }

            // The browser ("Internet") on Galaxy S6 has a bug where if one focuses the
            // input before the page has loaded, the fullscreen gets misplaced on load.
            // This might happen on other devices too, but we only work around it on
            // Samsung devices for now.
            // This has the drawback of not popping up the keyboard.
            // TODO: find a better workaround
            if (/samsungbrowser/i.test(navigator.userAgent)) {
                inputEle.blur();
                window.setTimeout(() => {
                    inputEle.focus();
                });
            }

            return formEle;
        }

        function hideDialog() {
            dialog.hide();
        }

        function removeFullscreenController(ele) {
            let value = ele.getAttribute('data-controller');
            value = value.replace(/\bfullscreenSearch\b/, '');
            ele.setAttribute('data-controller', value);
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/fullscreenSearch.js